import {
    createAsyncThunk,
    createSlice,
} from "@reduxjs/toolkit";

import {
    employeeAdvanceApi,
    employeeAttendanceApi,
} from "../../components/dashboard/components/AdminComponent/EmployeeManagement/utils/employeeApi";


const initialState = {

    records:
        [],

    pagination: {

        page:
            1,

        limit:
            31,

        totalRecords:
            0,

        totalPages:
            1,

    },

    loading:
        false,

    actionLoading:
        false,

    error:
        null,

};


export const fetchEmployeeAttendance =
    createAsyncThunk(
        "employeeAttendance/list",

        async (
            payload,
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeAttendanceApi
                        .getList(
                            payload
                        );


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to load attendance."
                    );

                }


                return {

                    records:
                        response?.data ||
                        [],

                    pagination:
                        response?.pagination ||
                        {},

                };

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to load attendance."
                );

            }

        }
    );


const employeeAttendanceSlice =
    createSlice({

        name:
            "employeeAttendance",

        initialState,

        reducers: {

            clearAttendanceError:
                (
                    state
                ) => {

                    state.error =
                        null;

                },

        },

        extraReducers:
            (
                builder
            ) => {

                builder

                    .addCase(
                        fetchEmployeeAttendance
                            .pending,
                        (
                            state
                        ) => {

                            state.loading =
                                true;

                            state.error =
                                null;

                        }
                    )

                    .addCase(
                        fetchEmployeeAttendance
                            .fulfilled,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.records =
                                action
                                    .payload
                                    ?.records ||
                                [];

                            state.pagination = {

                                ...state.pagination,

                                ...(
                                    action
                                        .payload
                                        ?.pagination ||
                                    {}
                                ),

                            };

                        }
                    )

                    .addCase(
                        fetchEmployeeAttendance
                            .rejected,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.error =
                                action.payload;

                        }
                    );

            },

    });


export const {
    clearAttendanceError,
} =
    employeeAttendanceSlice.actions;


export default employeeAttendanceSlice.reducer;